import { useQuery } from "@tanstack/react-query"
import { LIST_USER_WORKSPACES_KEY } from "../../../constants"
import { UserWorkspace } from "../../../types"
import { useWorkspaceService } from "../services/useWorkspaceService"

type UseUserWorkspacesProps = {
  enabled: boolean
  workspaceIds: string[]
}

const useUserWorkspaces = ({ enabled, workspaceIds }: UseUserWorkspacesProps) => {
  const workspaceService = useWorkspaceService()
  const workspaceIdsKey = workspaceIds.slice().sort().join(",")

  const { data, isLoading, error } = useQuery({
    queryKey: [LIST_USER_WORKSPACES_KEY, workspaceIdsKey],
    queryFn: (): Promise<UserWorkspace[]> => workspaceService.getUserWorkspaces(),
    enabled,
  })

  return {
    userWorkspaces: data ?? [],
    isLoading,
    error,
  }
}

export default useUserWorkspaces
